/**
 * The five colours permitted on askRichard and Lens surfaces (2026 Luxury
 * Escapes brand system, per brand_guide.html). No other colour belongs on
 * these surfaces. Retired and never reintroduced here: MUI blue[500]
 * #2196F3, Persian Green #01B18B, the admin indigo #304DAB, Midnight Grey
 * #363A45.
 */
export const BRAND_COLORS = {
  /** Structure: avatar fill, "ask", the Lens ring, primary buttons, chips, default chart series, header bands. */
  oceanTeal: '#0F464F',
  /** Default page and panel background; type on Ocean Teal. */
  sandyBeige: '#F9F7F1',
  /** Cards; the R on teal; chips behind marks on teal. */
  compassWhite: '#FFFFFF',
  /** "Richard", "Lens", body copy, card titles. */
  jetBlack: '#0F0C08',
  /** Accent only: the wordmark stop, the Lens dot, one highlighted chart series or marker, large display figures. Never text, never a background, never small type on teal. */
  coralGreen: '#4EFEB9',
} as const;

export type BrandColorName = keyof typeof BRAND_COLORS;

/**
 * Dark-mode pairs. Fields become Ocean Teal; a card sitting on that field is
 * a lighter teal with its own rule colour, never black.
 */
export const BRAND_DARK_MODE = {
  /** The page/panel field on a dark surface. */
  field: BRAND_COLORS.oceanTeal,
  /** A card on that teal field. */
  card: '#14545E',
  /** The rule between a card and its teal field. */
  cardRule: '#2B6068',
} as const;

/** Suisse Works: display type only (page and dashboard titles, metric card figures). Weights: 400 (and the 500 that ships). */
export const FONT_STACK_SUISSE_WORKS = `"Lens Suisse Works", Georgia, serif`;

/** Suisse Int'l: everything else. Weights: 400, 500, 600 only. */
export const FONT_STACK_SUISSE_INTL = `"Suisse Int'l", Helvetica, Arial, sans-serif`;

/**
 * The R avatar's sizes in px, by placement. Consumers should read from here
 * rather than choosing their own number.
 */
export const RICHARD_MARK_SIZES = {
  chatMessage: 32,
  railAndSessionList: 24,
  cardFooter: 18,
  tab: 16,
} as const;

export type RichardMarkSizeName = keyof typeof RICHARD_MARK_SIZES;
